import { sendLead } from '~/assets/js/services/event-tracker'

export default function submitInterests ({
  leadEmail,
  leadName,
  gtm,
  leadOrigin,
  leadSubscriptionType,
}) {
  sendLead(gtm, {
    leadOrigin,
    leadEmail,
    leadName,
    leadSubscriptionType,
  })
}
